import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { guardInviteReferrer } from './referrerGuard';

guardInviteReferrer(document, window.location.pathname);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);